export default __webpack_public_path__ + "static/media/la-solid-900.4184d740.eot";